import styled from 'styled-components'

const LoadingIcon = (props) => {
  const { color, loading = false } = props

  const style = color
    ? {
        borderTop: `3px solid ${color}`,
      }
    : {}
  const icon = loading ? <Icon style={style} /> : undefined
  return <span>{icon}</span>
}

const Icon = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid black;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: 0 auto;

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default LoadingIcon
